export const COLLECTIONS_LIST_KEY = 'COLLECTIONS_LIST';
export const COLLECTIONS_ONE_KEY = 'COLLECTIONS_ONE_KEY';

/* elements keys */
export const COLLECTION_ELEMENTS_LIST_KEY = 'COLLECTION_ELEMENTS_LIST';
